<template lang="pug">
div
  super-member(:activeCode="'cardMall'" :env="env" :jumpType="2" bizType="ride" :btnBgColor="'red'")
  div(@click='cesshi') 测试
</template>
<script>
import 'super-member/lib/index';
import config from '@/const/config';

export default {
  name: 'AAA',
  components: {
  },
  data() {
    return {
      env: config.env,
    };
  },
  methods: {
    cesshi() {
      this.$router.push('/mgm');
    },
  },
};
</script>
